"use strict";

/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.ssrWindow = {}));
})(void 0, function (exports) {
  'use strict';

  /* eslint-disable no-param-reassign */
  function isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
  }
  function extend(target, src) {
    if (target === void 0) {
      target = {};
    }
    if (src === void 0) {
      src = {};
    }
    Object.keys(src).forEach(function (key) {
      if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
        extend(target[key], src[key]);
      }
    });
  }
  var ssrDocument = {
    body: {},
    addEventListener: function () {},
    removeEventListener: function () {},
    activeElement: {
      blur: function () {},
      nodeName: ''
    },
    querySelector: function () {
      return null;
    },
    querySelectorAll: function () {
      return [];
    },
    getElementById: function () {
      return null;
    },
    createEvent: function () {
      return {
        initEvent: function () {}
      };
    },
    createElement: function () {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function () {},
        getElementsByTagName: function () {
          return [];
        }
      };
    },
    createElementNS: function () {
      return {};
    },
    importNode: function () {
      return null;
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    }
  };
  function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
  }
  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ''
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    },
    history: {
      replaceState: function () {},
      pushState: function () {},
      go: function () {},
      back: function () {}
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function () {},
    removeEventListener: function () {},
    getComputedStyle: function () {
      return {
        getPropertyValue: function () {
          return '';
        }
      };
    },
    Image: function () {},
    Date: function () {},
    screen: {},
    setTimeout: function () {},
    clearTimeout: function () {},
    matchMedia: function () {
      return {};
    },
    requestAnimationFrame: function (callback) {
      if (typeof setTimeout === 'undefined') {
        callback();
        return null;
      }
      return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
      if (typeof setTimeout === 'undefined') {
        return;
      }
      clearTimeout(id);
    }
  };
  function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
  }
  exports.extend = extend;
  exports.getDocument = getDocument;
  exports.getWindow = getWindow;
  exports.ssrDocument = ssrDocument;
  exports.ssrWindow = ssrWindow;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJpc09iamVjdCIsIm9iaiIsImNvbnN0cnVjdG9yIiwiT2JqZWN0IiwiZXh0ZW5kIiwidGFyZ2V0Iiwic3JjIiwia2V5cyIsImZvckVhY2giLCJrZXkiLCJsZW5ndGgiLCJzc3JEb2N1bWVudCIsImJvZHkiLCJhZGRFdmVudExpc3RlbmVyIiwicmVtb3ZlRXZlbnRMaXN0ZW5lciIsImFjdGl2ZUVsZW1lbnQiLCJibHVyIiwibm9kZU5hbWUiLCJxdWVyeVNlbGVjdG9yIiwicXVlcnlTZWxlY3RvckFsbCIsImdldEVsZW1lbnRCeUlkIiwiY3JlYXRlRXZlbnQiLCJpbml0RXZlbnQiLCJjcmVhdGVFbGVtZW50IiwiY2hpbGRyZW4iLCJjaGlsZE5vZGVzIiwic3R5bGUiLCJzZXRBdHRyaWJ1dGUiLCJnZXRFbGVtZW50c0J5VGFnTmFtZSIsImNyZWF0ZUVsZW1lbnROUyIsImltcG9ydE5vZGUiLCJsb2NhdGlvbiIsImhhc2giLCJob3N0IiwiaG9zdG5hbWUiLCJocmVmIiwib3JpZ2luIiwicGF0aG5hbWUiLCJwcm90b2NvbCIsInNlYXJjaCIsImdldERvY3VtZW50IiwiZG9jIiwiZG9jdW1lbnQiLCJzc3JXaW5kb3ciLCJuYXZpZ2F0b3IiLCJ1c2VyQWdlbnQiLCJoaXN0b3J5IiwicmVwbGFjZVN0YXRlIiwicHVzaFN0YXRlIiwiZ28iLCJiYWNrIiwiQ3VzdG9tRXZlbnQiLCJnZXRDb21wdXRlZFN0eWxlIiwiZ2V0UHJvcGVydHlWYWx1ZSIsIkltYWdlIiwiRGF0ZSIsInNjcmVlbiIsInNldFRpbWVvdXQiLCJjbGVhclRpbWVvdXQiLCJtYXRjaE1lZGlhIiwicmVxdWVzdEFuaW1hdGlvbkZyYW1lIiwiY2FsbGJhY2siLCJjYW5jZWxBbmltYXRpb25GcmFtZSIsImlkIiwiZ2V0V2luZG93Iiwid2luIiwid2luZG93Il0sInNvdXJjZXMiOlsiLi4vc3JjL2V4dGVuZC50cyIsIi4uL3NyYy9kb2N1bWVudC50cyIsIi4uL3NyYy93aW5kb3cudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsLG51bGwsbnVsbF0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7RUFBQTtFQUNBLFNBQVNBLFFBQVFBLENBQUNDLEdBQUc7SUFDbkIsT0FDRUEsR0FBRyxLQUFLLElBQUksSUFDWixPQUFPQSxHQUFHLEtBQUssUUFBUSxJQUN2QixhQUFhLElBQUlBLEdBQUcsSUFDcEJBLEdBQUcsQ0FBQ0MsV0FBVyxLQUFLQyxNQUFNO0VBRTlCO0VBRUEsU0FBU0MsTUFBTUEsQ0FBQ0MsTUFBZ0IsRUFBRUMsR0FBYTtJQUEvQixJQUFBRCxNQUFBO01BQUFBLE1BQUEsS0FBZ0I7SUFBQTtJQUFFLElBQUFDLEdBQUE7TUFBQUEsR0FBQSxLQUFhO0lBQUE7SUFDN0NILE1BQU0sQ0FBQ0ksSUFBSSxDQUFDRCxHQUFHLENBQUMsQ0FBQ0UsT0FBTyxDQUFDLFVBQUNDLEdBQUc7TUFDM0IsSUFBSSxPQUFPSixNQUFNLENBQUNJLEdBQUcsQ0FBQyxLQUFLLFdBQVcsRUFBRUosTUFBTSxDQUFDSSxHQUFHLENBQUMsR0FBR0gsR0FBRyxDQUFDRyxHQUFHLENBQUMsQ0FBQyxLQUMxRCxJQUNIVCxRQUFRLENBQUNNLEdBQUcsQ0FBQ0csR0FBRyxDQUFDLENBQUMsSUFDbEJULFFBQVEsQ0FBQ0ssTUFBTSxDQUFDSSxHQUFHLENBQUMsQ0FBQyxJQUNyQk4sTUFBTSxDQUFDSSxJQUFJLENBQUNELEdBQUcsQ0FBQ0csR0FBRyxDQUFDLENBQUMsQ0FBQ0MsTUFBTSxHQUFHLENBQUMsRUFDaEM7UUFDQU4sTUFBTSxDQUFDQyxNQUFNLENBQUNJLEdBQUcsQ0FBQyxFQUFFSCxHQUFHLENBQUNHLEdBQUcsQ0FBQyxDQUFDOztLQUVoQyxDQUFDO0VBQ0o7TUNuQk1FLFdBQVcsR0FBRztJQUNsQkMsSUFBSSxFQUFFLEVBQUU7SUFDUkMsZ0JBQWdCLFdBQUFBLENBQUEsSUFBSztJQUNyQkMsbUJBQW1CLFdBQUFBLENBQUEsSUFBSztJQUN4QkMsYUFBYSxFQUFFO01BQ2JDLElBQUksV0FBQUEsQ0FBQSxJQUFLO01BQ1RDLFFBQVEsRUFBRTtLQUNYO0lBQ0RDLGFBQWEsV0FBQUEsQ0FBQTtNQUNYLE9BQU8sSUFBSTtLQUNaO0lBQ0RDLGdCQUFnQixXQUFBQSxDQUFBO01BQ2QsT0FBTyxFQUFFO0tBQ1Y7SUFDREMsY0FBYyxXQUFBQSxDQUFBO01BQ1osT0FBTyxJQUFJO0tBQ1o7SUFDREMsV0FBVyxXQUFBQSxDQUFBO01BQ1QsT0FBTztRQUNMQyxTQUFTLFdBQUFBLENBQUE7T0FDVjtLQUNGO0lBQ0RDLGFBQWEsV0FBQUEsQ0FBQTtNQUNYLE9BQU87UUFDTEMsUUFBUSxFQUFFLEVBQUU7UUFDWkMsVUFBVSxFQUFFLEVBQUU7UUFDZEMsS0FBSyxFQUFFLEVBQUU7UUFDVEMsWUFBWSxXQUFBQSxDQUFBLElBQUs7UUFDakJDLG9CQUFvQixXQUFBQSxDQUFBO1VBQ2xCLE9BQU8sRUFBRTs7T0FFWjtLQUNGO0lBQ0RDLGVBQWUsV0FBQUEsQ0FBQTtNQUNiLE9BQU8sRUFBRTtLQUNWO0lBQ0RDLFVBQVUsV0FBQUEsQ0FBQTtNQUNSLE9BQU8sSUFBSTtLQUNaO0lBQ0RDLFFBQVEsRUFBRTtNQUNSQyxJQUFJLEVBQUUsRUFBRTtNQUNSQyxJQUFJLEVBQUUsRUFBRTtNQUNSQyxRQUFRLEVBQUUsRUFBRTtNQUNaQyxJQUFJLEVBQUUsRUFBRTtNQUNSQyxNQUFNLEVBQUUsRUFBRTtNQUNWQyxRQUFRLEVBQUUsRUFBRTtNQUNaQyxRQUFRLEVBQUUsRUFBRTtNQUNaQyxNQUFNLEVBQUU7OztFQUlaLFNBQVNDLFdBQVdBLENBQUE7SUFDbEIsSUFBTUMsR0FBRyxHQUNQLE9BQU9DLFFBQVEsS0FBSyxXQUFXLEdBQUdBLFFBQVEsR0FBSSxFQUFlO0lBQy9EdEMsTUFBTSxDQUFDcUMsR0FBRyxFQUFFOUIsV0FBVyxDQUFDO0lBQ3hCLE9BQU84QixHQUFHO0VBQ1o7TUN2RE1FLFNBQVMsR0FBRztJQUNoQkQsUUFBUSxFQUFFL0IsV0FBVztJQUNyQmlDLFNBQVMsRUFBRTtNQUNUQyxTQUFTLEVBQUU7S0FDWjtJQUNEZCxRQUFRLEVBQUU7TUFDUkMsSUFBSSxFQUFFLEVBQUU7TUFDUkMsSUFBSSxFQUFFLEVBQUU7TUFDUkMsUUFBUSxFQUFFLEVBQUU7TUFDWkMsSUFBSSxFQUFFLEVBQUU7TUFDUkMsTUFBTSxFQUFFLEVBQUU7TUFDVkMsUUFBUSxFQUFFLEVBQUU7TUFDWkMsUUFBUSxFQUFFLEVBQUU7TUFDWkMsTUFBTSxFQUFFO0tBQ1Q7SUFDRE8sT0FBTyxFQUFFO01BQ1BDLFlBQVksV0FBQUEsQ0FBQSxJQUFLO01BQ2pCQyxTQUFTLFdBQUFBLENBQUEsSUFBSztNQUNkQyxFQUFFLFdBQUFBLENBQUEsSUFBSztNQUNQQyxJQUFJLFdBQUFBLENBQUE7S0FDTDtJQUNEQyxXQUFXLEVBQUUsU0FBU0EsV0FBV0EsQ0FBQTtNQUMvQixPQUFPLElBQUk7S0FDWjtJQUNEdEMsZ0JBQWdCLFdBQUFBLENBQUEsSUFBSztJQUNyQkMsbUJBQW1CLFdBQUFBLENBQUEsSUFBSztJQUN4QnNDLGdCQUFnQixXQUFBQSxDQUFBO01BQ2QsT0FBTztRQUNMQyxnQkFBZ0IsV0FBQUEsQ0FBQTtVQUNkLE9BQU8sRUFBRTs7T0FFWjtLQUNGO0lBQ0RDLEtBQUssV0FBQUEsQ0FBQSxJQUFLO0lBQ1ZDLElBQUksV0FBQUEsQ0FBQSxJQUFLO0lBQ1RDLE1BQU0sRUFBRSxFQUFFO0lBQ1ZDLFVBQVUsV0FBQUEsQ0FBQSxJQUFLO0lBQ2ZDLFlBQVksV0FBQUEsQ0FBQSxJQUFLO0lBQ2pCQyxVQUFVLFdBQUFBLENBQUE7TUFDUixPQUFPLEVBQUU7S0FDVjtJQUNEQyxxQkFBcUIsV0FBQUEsQ0FBQ0MsUUFBUTtNQUM1QixJQUFJLE9BQU9KLFVBQVUsS0FBSyxXQUFXLEVBQUU7UUFDckNJLFFBQVEsRUFBRTtRQUNWLE9BQU8sSUFBSTs7TUFFYixPQUFPSixVQUFVLENBQUNJLFFBQVEsRUFBRSxDQUFDLENBQUM7S0FDL0I7SUFDREMsb0JBQW9CLFdBQUFBLENBQUNDLEVBQUU7TUFDckIsSUFBSSxPQUFPTixVQUFVLEtBQUssV0FBVyxFQUFFO1FBQ3JDOztNQUVGQyxZQUFZLENBQUNLLEVBQUUsQ0FBQzs7O0VBSXBCLFNBQVNDLFNBQVNBLENBQUE7SUFDaEIsSUFBTUMsR0FBRyxHQUFXLE9BQU9DLE1BQU0sS0FBSyxXQUFXLEdBQUdBLE1BQU0sR0FBSSxFQUFhO0lBQzNFOUQsTUFBTSxDQUFDNkQsR0FBRyxFQUFFdEIsU0FBUyxDQUFDO0lBQ3RCLE9BQU9zQixHQUFHO0VBQ1oiLCJpZ25vcmVMaXN0IjpbXX0=